import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormFieldComponent } from './form-field.component';
import { FormFieldDirective } from './form-field.directive';

@NgModule({
  declarations: [FormFieldComponent, FormFieldDirective],
  imports: [CommonModule],
  exports: [FormFieldComponent, FormFieldDirective],
})
export class FormFieldModule {}
